export default __webpack_public_path__ + "4e4a7dbc3ed91b85845d705ba9f156d5.png";